export default __webpack_public_path__ + "static/media/txt_link.e766d2e2.svg";